import { useAllureCashbackAccountQuery } from '@ocx/graphql';
import { useConfiguration } from '@ocx/data-configuration';

export type UseAllureCashbackAccountProps = {
  skip?: boolean;
};

export const useAllureCashbackAccount = (props: UseAllureCashbackAccountProps = {}) => {
  const { config } = useConfiguration();
  const { data, loading, error, refetch } = useAllureCashbackAccountQuery({
    skip: props.skip || !config.allureCashback.enabled,
    fetchPolicy: 'cache-and-network',
  });

  const account = data?.cashbackAccount ?? null;
  const balance = account != null ? account.balance : undefined;

  return { account, balance, loading, error, refetch };
};
